/**
 * Badge Constants
 */

export const CRITERIA_TYPE = {
  WORKOUTS: 1,
  STREAKS: 2,
  TENURE: 3,
  PROGRAMS: 4,
} as const;

export type CriteriaType = typeof CRITERIA_TYPE[keyof typeof CRITERIA_TYPE];

// Map criteria type values to display labels
export const CRITERIA_TYPE_LABELS: Record<number, string> = {
  [CRITERIA_TYPE.WORKOUTS]: "Workouts",
  [CRITERIA_TYPE.STREAKS]: "Streaks",
  [CRITERIA_TYPE.TENURE]: "Tenure",
  [CRITERIA_TYPE.PROGRAMS]: "Programs",
};

